// extracted by mini-css-extract-plugin
module.exports = {"main":"EmpCarousel_main__qr8K4","card":"EmpCarousel_card__1DBHW","imgClass":"EmpCarousel_imgClass__2_lPF","car":"EmpCarousel_car__3qb7R","btns":"EmpCarousel_btns__1Zchm"};